// Parámetros de /radar, /radar/events y /export/radar en UN sitio (§76: el Excel
// debe contener lo que estás viendo; §90: el filtro por grupo de hitos entra en
// las tres llamadas o en ninguna).

export type RadarFilters = {
  q: string;            // texto libre (cuenta a partir de 2 caracteres)
  source: string;       // código de fuente ("" = todas)
  hitoGroup: string;    // "1".."11" ("" = todos los grupos)
};

export function isSearching(f: RadarFilters): boolean {
  // El grupo NO activa la tabla de búsqueda: filtra la vista del mes.
  return f.q.trim().length >= 2 || f.source !== "";
}

export function radarMonthParams(f: RadarFilters, month?: string): URLSearchParams {
  const p = new URLSearchParams();
  if (month) p.set("month", month);
  if (f.hitoGroup) p.set("hito_group", f.hitoGroup);
  return p;
}

export function radarEventParams(f: RadarFilters, page: number, limit = 50): URLSearchParams {
  const p = new URLSearchParams({ page: String(page), limit: String(limit) });
  if (f.q.trim().length >= 2) p.set("search", f.q.trim());
  if (f.source) p.set("source", f.source);
  if (f.hitoGroup) p.set("hito_group", f.hitoGroup);
  return p;
}

/** Sin búsqueda se exporta el mes que estás viendo; con búsqueda, todo el histórico filtrado. */
export function radarExportParams(f: RadarFilters, month: string | undefined): URLSearchParams {
  const p = new URLSearchParams();
  if (f.q.trim().length >= 2) p.set("search", f.q.trim());
  if (f.source) p.set("source", f.source);
  if (f.hitoGroup) p.set("hito_group", f.hitoGroup);
  if (!isSearching(f) && month) {
    p.set("from_date", `${month}-01T00:00:00`);
    const [yy, mm] = month.split("-").map(Number);
    const end = new Date(Date.UTC(mm === 12 ? yy + 1 : yy, mm === 12 ? 0 : mm, 1));
    p.set("to_date", end.toISOString());
  }
  return p;
}
